import { render, staticRenderFns } from "./IpRangesTabManagement.vue?vue&type=template&id=99c75060&scoped=true&"
import script from "./IpRangesTabManagement.vue?vue&type=script&lang=js&"
export * from "./IpRangesTabManagement.vue?vue&type=script&lang=js&"
import style0 from "./IpRangesTabManagement.vue?vue&type=style&index=0&id=99c75060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c75060",
  null
  
)

export default component.exports